import React, { useCallback, useMemo, useState } from 'react';
import { CTAButton, PromotionalMessaging } from 'components';
import { Show } from 'components/Functional';
import { DSButton } from './styled';
import itly from 'itly';
import { convertToReportingProduct } from 'analytics/itly/helpers/product';
import { getShipCutoffContentBlock } from 'helpers/products';
import Block from 'components/CMS/Block';
import { useBlock } from '../../hooks/useBlock';
import { DESIGN_SERVICES_BOOKS } from 'components/constants/products';
import { useProductForm } from '../../hooks/useProductForm';
import { useProduct } from '../../hooks/useProduct';
import { useProductSelectors } from 'hooks/useProductSelectors';
import { useProductPrice } from '../../hooks/useProductPrice';
import * as styles from './styles.module.scss';
import { getMobileTestCTALabel } from './helpers';

export const PDPFormMobileTest: React.FC = () => {
  const price = useProductPrice();

  const { inputs, handleDesignItForMeClick, handleSubmit } = useProductForm();
  const { product } = useProduct();
  const { getSLACategory } = useProductSelectors();
  const [ctaImpressionFired, setCtaImpressionFired] = useState(false);
  const { getBlock } = useBlock();

  const shipCutoffContentBlockId = useMemo(() => {
    const slaCategory = getSLACategory(product.sku);
    return slaCategory ? getShipCutoffContentBlock(slaCategory) : null;
  }, [getSLACategory, product.sku]);

  const isShipCutoffContentBlockActive = useMemo(
    () => shipCutoffContentBlockId != null && getBlock(shipCutoffContentBlockId)?.active,
    [shipCutoffContentBlockId, getBlock]
  );

  const ctaButtonOnVisible = useCallback(() => {
    if (!ctaImpressionFired) {
      setCtaImpressionFired(true);
      itly.ctaImpression(convertToReportingProduct(product));
    }
  }, [ctaImpressionFired, product]);

  const isDSsku = DESIGN_SERVICES_BOOKS.find((book) => book.sku === product.sku);

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // Preload hover assets
    for (const input of inputs) {
      for (const optionName in input.options) {
        if (input.options[optionName].hoverImage) {
          new Image().src = input.options[optionName].hoverImage;
        }
      }
    }
  }

  const formCTALabel = getMobileTestCTALabel(price);

  return (
    <>
      <Show when={product.promotionalMessage && !isShipCutoffContentBlockActive}>
        <PromotionalMessaging>{product.promotionalMessage}</PromotionalMessaging>
      </Show>
      <Show when={isShipCutoffContentBlockActive}>
        <Block
          id={shipCutoffContentBlockId}
          render={(content) => <div dangerouslySetInnerHTML={{ __html: content }} />}
        />
      </Show>

      {/* TODO: Update click handler to open project option step config */}
      <CTAButton onClick={handleSubmit} addToCartLabel={formCTALabel} onVisible={ctaButtonOnVisible}
                 className={styles.ctaButton} />
      <Show when={isDSsku?.sku !== undefined}>
        <DSButton onClick={() => handleDesignItForMeClick(isDSsku?.url)} id="design-services-button"
                  className={styles.designItForMeButton}>
          DESIGN IT FOR ME
        </DSButton>
        <div className={styles.dsContent}>
          Have one of our expert designers create the album you've always envisioned.
        </div>
      </Show>
    </>
  );
};
